import { Image, Text, View } from "@react-pdf/renderer";
import React from "react";

import { sectionStyles } from "../styles";

interface IReviewsTimelineSectionProps {
  title: string;
  chartImage: string | undefined;
  noDataLabel: string;
}

export const ReviewsTimelineSection: React.FunctionComponent<
  IReviewsTimelineSectionProps
> = ({ title, chartImage, noDataLabel }) => {
  return (
    <View style={sectionStyles.reviewsTimelineContainer}>
      <Text style={sectionStyles.subTitle}>{title}</Text>
      {chartImage ? (
        <Image src={chartImage} style={sectionStyles.chartImage} />
      ) : (
        <Text style={sectionStyles.noData}>{noDataLabel}</Text>
      )}
    </View>
  );
};
